<template>
    <div class="contact">
        <div class="contact-top">
            <div>
                <div class="contact-title">联系我们</div>
                <div class="contact-desc">我们致力于为您提供丰富的服务咨询, 及全面的技术售后服务</div>
            </div>
        </div>
        <div class="info">
            <div style="flex: 1;display: flex;">
                <div class="erweim-item">
                    <p style="color: #000000;font-size: 20px;">关注腾宇慧住</p>
                    <p style="color: #000000;font-size: 20px;">官方公众号</p>
                    <img style="width: 150px;margin: 20px auto;"
                         src="../../../assets/images/qrcode_for_gh_7e444c0c022f_344.jpg"/>
                    <p style="font-size: 14px;">产品资讯、最新服务、合作咨询</p>
                </div>
                <div class="erweim-item">
                    <p style="color: #000000;font-size: 20px;">关注腾宇慧住</p>
                    <p style="color: #000000;font-size: 20px;">微信小程序</p>
                    <img style="width: 150px;margin: 20px auto;" src="../../../assets/images/gh_0b8db7d66c43_344.jpg"/>
                    <p style="font-size: 14px;">线上订房、办理入住、办理退房</p>
                </div>
            </div>
            <div style="flex: 1;">
                <div class="lxfs-item">
                    <div style="width: 60px;">
                        <img style="width: 30px;" src="../../../assets/images/khdh-icon.png"/>
                    </div>
                    <div>
                        <div style="text-align: left;font-size: 16px;">客服电话</div>
                        <div style="text-align: left;margin-top: 10px;font-size: 14px;">0572-3305066</div>
                        <div style="text-align: left;margin-top: 10px;color: #8f8f8f;font-size: 14px;">7x24小时全天服务</div>
                    </div>
                </div>
                <div class="lxfs-item">
                    <div style="width: 60px;">
                        <img style="width: 30px;" src="../../../assets/images/schz-icon.png"/>
                    </div>
                    <div>
                        <div style="text-align: left;font-size: 16px;">市场合作</div>
                        <div style="text-align: left;margin-top: 10px;font-size: 14px;">292300733@qq.com</div>
                    </div>
                </div>
                <div class="lxfs-item">
                    <div style="width: 60px;">
                        <img style="width: 30px;" src="../../../assets/images/ywhz-icon.png"/>
                    </div>
                    <div>
                        <div style="text-align: left;font-size: 16px;">业务合作</div>
                        <div style="text-align: left;margin-top: 10px;font-size: 14px;">292300733@qq.com</div>
                    </div>
                </div>
                <div class="lxfs-item">
                    <div style="width: 60px;">
                        <img style="width: 30px;" src="../../../assets/images/schz-icon.png"/>
                    </div>
                    <div>
                        <div style="text-align: left;font-size: 16px;">媒体联络</div>
                        <div style="text-align: left;margin-top: 10px;font-size: 14px;">292300733@qq.com</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact',
        data() {
            return {}
        }
    }
</script>

<style>

    .contact {
        width: 100%;
        min-width: 1290px;
        background: #f1f1f1;
        min-height: 90vh;
    }

    .contact-top {
        width: 100%;
        min-width: 1290px;
        background: url(../../../assets/images/contact.jpg) 100% no-repeat;
        background-size: cover;
        height: 300px;
        margin-bottom: 90px;
        padding-top: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .contact-title {
        font-size: 40px;
        color: black;
    }

    .contact-desc {
        margin-top: 20px;
    }

    .info {
        width: 1080px;
        margin: auto;
        display: flex;
    }

    .erweim-item {
        background: #ffffff;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        width: 240px;
        padding: 20px 0;
        margin-left: 20px;
    }

    .lxfs-item {
        display: flex;
        margin-bottom: 26px;
    }
</style>